import React, { useEffect, useState } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import "./CreateCampaignTemplate.css";
import "./nameCampaign.css";


const InncreaseCampaignBudgetForm = () => {

  return (
    <div className="budget-form-container">
    <div className="budget-form-header">Time period for budget increase</div>
    <div style={{ display: "flex", gap: "10px" }}>
      <div style={{ display: "flex", alignItems: "center" }}>
        <div
          className="common-input-container"
          style={{ width: "150px" }}
          data-label="start-date"
        >
          {/* <input
            type="date"
            style={{
              borderBottomRightRadius: "0px",
              borderTopRightRadius: "0px",
              height: "38px",
              borderBottomLeftRadius: "5px",
              borderTopLeftRadius: "5px",
              border: "1px solid lightgray",
              color: "lightgray",
            }}
          /> */}

<Field type="date" name="startDate"
                   style={{
                    borderBottomRightRadius: "0px",
                    borderTopRightRadius: "0px",
                    height: "38px",
                    borderBottomLeftRadius: "5px",
                    borderTopLeftRadius: "5px",
                    border: "1px solid lightgray",
                    color: "lightgray",
                  }}
          />
          <ErrorMessage name="startDate" component="div" className="error-message" />

        </div>
        <div className="common-input-container" style={{ width: "150px" }}>
          {/* <input
            type="time"
            style={{
              borderBottomLeftRadius: "0px",
              borderTopLeftRadius: "0px",
              height: "38px",
              borderBottomRightRadius: "5px",
              borderTopRightRadius: "5px",
              border: "1px solid lightgray",
            }}
          /> */}
          <Field type="time" name="startTime"
                 style={{
                  borderBottomLeftRadius: "0px",
                  borderTopLeftRadius: "0px",
                  height: "38px",
                  borderBottomRightRadius: "5px",
                  borderTopRightRadius: "5px",
                  border: "1px solid lightgray",
                }}
          />
          <ErrorMessage name="startTime" component="div" className="error-message" />


        </div>
      </div>
      <div
        style={{
          display: "flex",
          alignItems: "center",
        }}
      >
        <div
          className="common-input-container"
          style={{ width: "150px" }}
          data-label="End-date"
        >
          {/* <input
            type="date"
            style={{
              borderBottomRightRadius: "0px",
              borderTopRightRadius: "0px",
              height: "38px",
              borderBottomLeftRadius: "5px",
              borderTopLeftRadius: "5px",
              border: "1px solid lightgray",
              color: "lightgray",
            }}
          /> */}
           <Field type="date" name="endDate"
           style={{
            borderBottomRightRadius: "0px",
            borderTopRightRadius: "0px",
            height: "38px",
            borderBottomLeftRadius: "5px",
            borderTopLeftRadius: "5px",
            border: "1px solid lightgray",
            color: "lightgray",
          }}
          />
          <ErrorMessage name="endDate" component="div" className="error-message" />
          
        </div>
        <div className="common-input-container" style={{ width: "150px" }}>
    
          <Field type="time" name="endTime"
          style={{
            borderBottomLeftRadius: "0px",
            borderTopLeftRadius: "0px",
            height: "38px",
            borderBottomRightRadius: "5px",
            borderTopRightRadius: "5px",
            border: "1px solid lightgray",
          }}
        />
        <ErrorMessage name="endTime" component="div" className="error-message" />


        </div>
      </div>
    </div>

    <div className="budget-form-group">
      <label>Enter Bid Strategy</label>

      <Field as="select" name="bidStrategy">
      <option value="" disabled>
        Select strategy
      </option>
      <option value="increase">
        Increase daily budget by value amount
      </option>
    </Field>
    <ErrorMessage name="bidStrategy" component="div" className="error-message" />


      <div className="budget-amount-group">
        <span>₹</span>

        <Field type="number" name="bidAmount" placeholder="50.00" />
        <ErrorMessage name="bidAmount" component="div" className="error-message" />

        <span>INR</span>

      </div>
    </div>

    <div style={{ display: "flex", gap: "20px", alignItems: "center" }}>
      <p className="budget-info-text">
        Meta will aim to spend an average of ₹250 a day (a ₹50 increase) from
        Nov 28 to Nov 29.
      </p>

      <button className="budget-remove-btn">Remove this time period</button>
    </div>
    <button className="budget-add-btn">Add More Time Period</button>
  </div>

  );
};

export default InncreaseCampaignBudgetForm;
